import axios from "axios";

const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// On a custom domain, call the API on the same site so the login cookie stays first-party.
const sameSite = (() => { try { return new URL(ENV_BACKEND_URL).origin === window.location.origin; } catch { return true; } })();
const BACKEND_URL = sameSite ? ENV_BACKEND_URL : window.location.origin;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the acting org id (super admin "Act as") on every request.
api.interceptors.request.use((config) => {
  const orgId = localStorage.getItem("acting_org_id");
  if (orgId) config.headers["X-Org-Id"] = orgId;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
